import { ref, onUnmounted } from 'vue'
import { successState, progressState } from '@/components/scenario-loading/constants/progressState'
import type { CalculationProgressInfo } from '@/components/scenario-result/type/type'
import { useScenarioStore } from '@/stores/scenario'

export function useCalculationPolling() {
  const scenarioStore = useScenarioStore()
  const calculationProgressInfo = ref<CalculationProgressInfo>()
  const steps = ref<string[]>([])
  let intervalId: number | undefined

  const startPolling = async (scenarioId: number, intervalMs = 1000) => {
    if (calculationProgressInfo.value?.state === successState) return

    intervalId = window.setInterval(async () => {
      calculationProgressInfo.value = await scenarioStore.getScenarioProgress(scenarioId)
      const progressInfo = calculationProgressInfo.value

      if (!progressInfo) {
        stopPolling()
        return
      }

      if (progressInfo.state !== progressState) {
        stopPolling()
        await scenarioStore.fetchItem(scenarioId)
        return
      }

      const newMessage = progressInfo.message
      if (!newMessage) return

      const existingIndex = steps.value.indexOf(newMessage)
      if (existingIndex !== -1) {
        steps.value.splice(existingIndex, 1)
      }
      steps.value.push(newMessage)
    }, intervalMs)
  }

  const stopPolling = () => {
    if (intervalId) {
      clearInterval(intervalId)
      intervalId = undefined
    }
  }

  onUnmounted(() => {
    stopPolling()
  })

  return {
    calculationProgressInfo,
    steps,
    startPolling,
    stopPolling
  }
}
